// extracted by css-extract-rspack-plugin
export default {"toggle":"rrjwG5A_20aXMzjU"};